import httpClient from "../httpClient";

import { dispatch } from "../../state/store";
import { setGroupError, setGroupsConfigs } from "../../state/ducks";

import { strCode } from "../../consts";
import notificationService from "../notification/notificationService";
import { t } from "../i18n/localizationService";
import log from "../logger/log";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = async (endpoint) => {
  return `${apiUrl}/app-type-management/${endpoint}`;
};

const fetchGroup = async (appType) => {
  const baseUrl = await getRequestData("get-app-type-group-configs");

  const url = `${baseUrl}?appType=${appType}`;

  const data = await httpClient.get(url);

  dispatch(
    setGroupsConfigs({
      appType,
      groups: data?.data?.map((config) => config.group)
    })
  );
};

const fetchSelectedGroup = async (appType) => {
  try {
    dispatch(setGroupError(null));

    const baseUrl = await getRequestData("get-app-type-group-configs");

    const url = `${baseUrl}?appType=${appType}`;

    const { data } = await httpClient.get(url);

    return data;
  } catch (e) {
    dispatch(setGroupError(true));
    log.error("groupService: Failed to fetch app group");
    notificationService.showError({
      title: t(strCode.GET_APP_GROUP_ERROR),
      message: e?.response?.data?.message ? e.response.data.message : e?.toString()
    });
  }
};

const groupsService = { fetchGroup, fetchSelectedGroup };

export default groupsService;
